import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaTag,
  FaDownload,
  FaList,
  FaThLarge,
  FaDirections,
  FaFilter,
  FaCalendarDay,
  FaRupeeSign,
  FaClock,
  FaPaw,
  FaMapMarkerAlt,
  FaTimes,
} from "react-icons/fa";
import { MdOnlinePrediction, MdOutlineWifiOff } from "react-icons/md";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Listview } from "./Listview";
import Viewinvoice from "./Viewinvoice";
import downloadInvoicePDF from "./downloadInvoicePDF";
import config from "../../config";

export const Bookinglist = () => {
  const auth = useSelector((state) => state.auth || {});
  const { customer_data } = auth || {};
  const token = localStorage.getItem("token");
  const clientId = customer_data?._id || customer_data?.id;
  const [quickRange, setQuickRange] = useState("");
  const [activeStatusTab, setActiveStatusTab] = useState("Upcoming");
  const [appointments, setAppointments] = useState([]);
  const [boardingBookings, setBoardingBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  // const [orderIdFilter, setOrderIdFilter] = useState("");
  // const [dateFilter, setDateFilter] = useState("");
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("all");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [orders, setOrders] = useState([]);
  const [showInvoice, setShowInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [viewMode, setViewMode] = useState("card");
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [ordersLoaded, setOrdersLoaded] = useState(false);
  const [bookingsLoaded, setBookingsLoaded] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState();
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const API_BASE_URL = config.API_BASE_URL;

  const getLocalDateString = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API_BASE_URL}/customer/getCustomerOrders`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = res.data?.data || [];
      setOrders(data);
      setFilteredOrders(data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  const groupByOrderNumber = (bookings) => {
    const grouped = {};
    bookings.forEach((item) => {
      if (!grouped[item.order_number]) {
        grouped[item.order_number] = { ...item, items: [] };
      }
      grouped[item.order_number].items.push(item);
    });
    return Object.values(grouped);
  };

  //const isPastBooking = (item) => {
  //const today = new Date();
  //today.setHours(0, 0, 0, 0);

 // const relevantDate =
    //item.type === "boarding"
     // ? new Date(item.end_date || item.start_date)
    //  : new Date(item.start_date);

  //relevantDate.setHours(0, 0, 0, 0);

  //return relevantDate < today;
//};

 //const filterStatusGroup = (orders) => {
  //return orders.filter((order) => {
   // const hasActiveItem = order.items.some((item) => {
     // const status = item.status?.toLowerCase();
     // const isPast = isPastBooking(item);
     // return (
       // ["booked", "confirmed", "started", "no_show"].includes(status) &&
       // !isPast
     // );
   // });

    //const allItemsPastOrClosed = order.items.every((item) => {
      //const status = item.status?.toLowerCase();
      //const isPast = isPastBooking(item);
     // return (
      //  ["completed", "cancel", "cancelled"].includes(status) ||
     //   isPast
     // );
    //});
    //if (activeStatusTab === "Upcoming") return hasActiveItem;
    //if (activeStatusTab === "Past") return allItemsPastOrClosed;
    //return true;
  //});
//};

  const filterStatusGroup = (items) => {
    
    if (activeStatusTab === "Upcoming") {
      return items.filter((order) => {
        // Check if ANY item in the order has upcoming status
        return order.items.some((item) =>
          ["booked", "confirmed", "started"].includes(item.status),
        );
      });
    }

    if (activeStatusTab === "Past") {
      return items.filter((order) => {
        // Check if ALL items are cancelled/completed
      return order.items.every((item) =>
          ["completed","closed", "cancel", "cancelled", "no_show"].includes(item.status),
       );
      });
    }

    return items;
  };

   const STATUS_OPTIONS = {
      Upcoming: ["booked", "confirmed", "started"],
      Past: ["completed", "cancelled", "no_show"],
    };

  const statusOptions = STATUS_OPTIONS[activeStatusTab].map((status) => ({
    value: status,
    label: status.replace("_", " ").toUpperCase(),
  }));

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    //fetchOrders();
    fetchOrders().finally(() => setOrdersLoaded(true));
    //if (!clientId) return;
    if (!clientId) {
    setBookingsLoaded(true);
    return;
  }
    const fetchBookings = async () => {
      setLoading(true);
      try {
        const requests = [
          axios.get(`${API_BASE_URL}/customer/getbooking`, {
            params: { clientId },
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${API_BASE_URL}/customer/getboardingbooking`,
            {
              params: { clientId },
              headers: { Authorization: `Bearer ${token}` },
            },
          ),
        ];

        const [apptResult, boardResult] = await Promise.allSettled(requests);

        if (apptResult.status === "fulfilled") {
          setAppointments(apptResult.value?.data?.data || []);
        } else {
          setAppointments([]);
        }

        if (boardResult.status === "fulfilled") {
          setBoardingBookings(boardResult.value?.data?.data || []);
        } else {
          setBoardingBookings([]);
        }
      } catch (error) {
        toast.error("Something went wrong while fetching bookings");
      } finally {
        setBookingsLoaded(true);
        setLoading(false);
      }
    };
    fetchBookings();
  }, [clientId, token]);

  const fetchInvoice = async (orderData) => {
    try {
      setLoading(true);
      const orderId = orderData.order_id;
      const vendorId = orderData.vendor_id;


      const res = await axios.get(
        `${API_BASE_URL}/invoice/getorderinvoice`,
        {
          params: {
            orderId,
            vendorId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      

      return res.data?.data;
    } catch (error) {
      console.error("Invoice Error:", error);
      toast.error("Failed to fetch invoice");
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (!quickRange || quickRange === "") return;
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const todayStr = getLocalDateString(today);
      let from = "";
      let to = todayStr;

      switch (quickRange) {
        case "today":
          from = todayStr;
          to = todayStr;
          break;

        case "last_7":
          const d7 = new Date(today);
          d7.setDate(d7.getDate() - 7);
          from = getLocalDateString(d7);
          break;

        case "last_30":
          const d30 = new Date(today);
          d30.setDate(d30.getDate() - 30);
          from = getLocalDateString(d30);
          break;

        case "this_month":
          const year = today.getFullYear();
          const month = today.getMonth();
          const start = new Date(year, month, 1);
          from = getLocalDateString(start);
          const end = new Date(year, month + 1, 0);
          to = getLocalDateString(end);
          break;

        default:
          from = "";
          to = "";
          break;
      }
      setFromDate(from);
      setToDate(to);
      
    }, [quickRange]);

  const allBookings = [...appointments, ...boardingBookings].sort((a, b) => {
  const dateA = new Date(a.start_date);
  const dateB = new Date(b.start_date);
  
  if (activeStatusTab === "Upcoming") {
      return dateA - dateB; // Soonest upcoming at the top
  } else {
      return dateB - dateA; // Most recent past at the top
      }
  });
  const groupedBookings = groupByOrderNumber(allBookings);
  const activeData = filterStatusGroup(groupedBookings);

  const getActiveQuickRange = () => {
    if (!fromDate || !toDate) return quickRange || "";

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const todayStr = getLocalDateString(today);

    if (fromDate === todayStr && toDate === todayStr) return "today";

    const d7 = new Date(today);
    d7.setDate(d7.getDate() - 7);
    const last7Str = getLocalDateString(d7);
    if (fromDate === last7Str && toDate === todayStr) return "last_7";

    const d30 = new Date(today);
    d30.setDate(d30.getDate() - 30);
    const last30Str = getLocalDateString(d30);
    if (fromDate === last30Str && toDate === todayStr) return "last_30";

    const year = today.getFullYear();
    const month = today.getMonth();
    const first = new Date(year, month, 1);
    const last = new Date(year, month + 1, 0);
    const firstStr = getLocalDateString(first);
    const lastStr = getLocalDateString(last);

    if (fromDate === firstStr && toDate === lastStr) return "this_month";

    return "custom";
  };

   
  const filteredData = activeData.filter((booking) => {
    //const lowerQuery = searchText.toLowerCase().trim();
    const lowerQuery = searchText.toLowerCase().trim().replace(/[₹,\s]/g, "");

    const searchMatch =
    !lowerQuery ||
    booking.order_number?.toLowerCase().includes(lowerQuery) ||
    (() => {
      const totalBookingAmount = booking.items.reduce((sum, item) => {
        return (
          sum +
          (item.grand_total ||
            (item.total_price || 0) + (item.additional_amount || 0))
        );
      }, 0);

      const priceMatch =
        totalBookingAmount.toString().includes(lowerQuery) ||
        Math.floor(totalBookingAmount).toString() === lowerQuery ||
        Math.round(totalBookingAmount).toString() === lowerQuery;

      const textMatch = booking.items.some((item) =>
         [
          item.service_name, 
          // item.pet_name, 
          item.vendor_brand_name, 
          item.status, 
          // item.vendor_type, 
         // item.service_category_name,
          ]
          .filter(Boolean)
          .some((str) => str.toLowerCase().includes(lowerQuery))
      );

      return priceMatch || textMatch;
    })();
    
    const dateMatch =
      fromDate || toDate
        ? booking.items.some((item) => {
            if (!item.start_date) return false;
            const start = new Date(item.start_date);
            const d = getLocalDateString(start);   // ← now works
            if (fromDate && d < fromDate) return false;
            if (toDate && d > toDate) return false;
            return true;
          })
        : true;
    const paymentMatch =
      paymentStatus === "all"
        ? true
        : booking.items.some((i) => i.payment_status === paymentStatus);

     const statusMatch = !selectedStatus
   // ? true
   // : booking.items.some(
      // (item) => item.status?.toLowerCase() === selectedStatus
     // );
      ? true
  : activeStatusTab === "Past"
  ? booking.items.some((item) => {
      const itemStatus = item.status?.toLowerCase();
      
      if (selectedStatus === "completed") {
        // Show if ANY item is completed OR closed
        return itemStatus === "completed" || itemStatus === "closed";
      }
      
      if (selectedStatus === "cancelled") {
        // Show if ANY item is cancelled
        return itemStatus === "cancel" || itemStatus === "cancelled";
      }
      
      if (selectedStatus === "no_show") {
        // Show if ANY item is no_show
        return itemStatus === "no_show";
      }
      
      return itemStatus === selectedStatus;
    })
  : booking.items.some((item) => item.status?.toLowerCase() === selectedStatus);
    return searchMatch && dateMatch && paymentMatch && statusMatch;
  });

  useEffect(() => {
    setSelectedStatus();
  }, [activeStatusTab]);
  
  const activeFilterCount = [
    fromDate,
    toDate,
    quickRange,
    paymentStatus !== "all",
  ].filter(Boolean).length;

  const clearBookingFilters = () => {
    setSearchText("");
    setFromDate("");
    setToDate("");
    setQuickRange("");
    setPaymentStatus("all");
    setShowMobileFilters(false);
  };

  const effectiveViewMode = isMobileView ? "card" : viewMode;

 
  const BookingCard = ({ booking }) => {
  // Calculate grand total using grand_total or total_price + additional_amount
  const totalAmount = Number(
    booking.items
      .reduce((sum, s) => {
        // Use grand_total if available, otherwise calculate total_price + additional_amount
        const itemTotal = s.grand_total || 
                         (s.total_price || 0) + (s.additional_amount || 0);
        return sum + itemTotal;
      }, 0)
      .toFixed(0),
  );

   // Calculate total paid amount and remaining amount from API fields
  const totalPaidAmount = Number(
    booking.items
      .reduce((sum, s) => {
        const paidAmount = s.paid_amount || 0;
        return sum + paidAmount;
      }, 0)
      .toFixed(0)
  );

   const totalRemainingAmount = Number(
    booking.items
      .reduce((sum, s) => {
        // Use remaining_amount from API if available, otherwise calculate
        const remaining = s.remaining_amount ?? 
                         (s.grand_total - (s.paid_amount || 0));
        return sum + (remaining > 0 ? remaining : 0);
      }, 0)
      .toFixed(0)
  );

  // Determine payment status for the entire order
  const getOrderPaymentStatus = () => {
    // Check if all items are paid
    const allPaid = booking.items.every(item => 
      item.payment_status?.toLowerCase() === "paid"
    );
    if (allPaid) return "paid";

    // Check if any item has partial payment
    const hasPartial = booking.items.some(item => 
      item.payment_status?.toLowerCase() === "partial"
    );
    if (hasPartial) return "partial";

    // Check if any item has unpaid status
    const hasUnpaid = booking.items.some(item => 
      item.payment_status?.toLowerCase() === "unpaid"
    );
    if (hasUnpaid) return "unpaid";

    return "unpaid";
  };

  const orderPaymentStatus = getOrderPaymentStatus();


  // Check if all items are paid
 // const isFullyPaid = booking.items.every(item => 
  //  item.payment_status?.toLowerCase() === "paid"
 // );

  const getStatusColor = (status) => {
    const s = status.toLowerCase();
    if (s === "completed") return "bg-green-100 text-green-800";
    if (s === "cancel" || s === "cancelled") return "bg-red-100 text-red-800";
    return "bg-amber-100 text-amber-800";
  };

  const formatStatus = (status) =>
    status.toLowerCase() === "cancel"
      ? "Cancelled"
      : status.charAt(0).toUpperCase() + status.slice(1);

  const officeAddress = booking.items[0]?.vendor_address?.officeAddress;
  const lat = officeAddress?.latitude;
  const lng = officeAddress?.longitude;

  let destination = "Bengaluru, Karnataka"; // fallback text if no coords
  if (lat && lng) {
    destination = `${lat},${lng}`;
  }
  const encodedDestination = encodeURIComponent(destination);
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}&travelmode=driving`;
  
  const truncateString = (str, maxLength = 20) => {
  if (!str) return '';
  return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
};

  return (
    <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bookinglist">
      {/* Header */}
      <div className="overflow-auto">
        <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-4 sm:px-6 py-5 border-b border-gray-100 overflow-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest leading-none mb-1">
                  Order ID
                </p>
                <p className="text-lg sm:text-xl font-black text-gray-900 leading-none">
                  #{booking.order_number}
                </p>
              </div>
              <div
                className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-tight ${
                  booking.order_type === "online"
                    ? "bg-green-100 text-green-700 border border-green-200"
                    : "bg-gray-100 text-gray-600 border border-gray-200"
                }`}
              >
                {booking.order_type === "online" ? (
                  <>
                    <MdOnlinePrediction size={14} />
                    ONLINE
                  </>
                ) : (
                  <>
                    <MdOutlineWifiOff size={14} />
                    OFFLINE
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3 sm:justify-end">
              {/* Payment Status Badge */}
              <span
                className={`px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider ${
                  orderPaymentStatus === "paid"
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : "bg-red-100 text-red-800 border border-red-200"
                }`}
              >
                {orderPaymentStatus === "paid" 
                  ? "Paid" 
                  : "Balance Due"}
              </span>

              {/* Amount Display based on payment status */}
              {orderPaymentStatus === "paid" ? (
                <span className="text-xl sm:text-2xl font-black text-gray-900 flex items-center">
                  <FaRupeeSign className="text-sm" /> {booking.grand_total.toFixed(0)}
                </span>
              ) : orderPaymentStatus === "partial" ? (
                <div className="text-right">
                  <span className="text-lg sm:text-xl font-black text-gray-900 flex items-center">
                    <FaRupeeSign className="text-sm" /> {totalRemainingAmount}
                  </span>
                  <p className="text-[10px] text-gray-500">
                    Total: ₹{totalAmount} | Paid: ₹{totalPaidAmount}
                  </p>
                </div>
              ) : (
                <span className="text-xl sm:text-2xl font-black text-gray-900 flex items-center">
                  <FaRupeeSign className="text-sm" /> {totalRemainingAmount}
                </span>
              )}

              {/* Pay Now button - show for partial and unpaid */}
              {/* {orderPaymentStatus !== "paid" && (
                <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-xl text-xs shadow-md transition active:scale-95">
                  Pay Now
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {/* Vendor Info */}
      {booking.items[0]?.vendor_brand_name && (
        <div className="px-4 sm:px-6 py-4 bg-blue-50/30 border-b border-gray-100">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              {booking.vendor_info?.logo ? (
                <img
                  src={booking.vendor_info.logo}
                  alt="Vendor Logo"
                  className="w-10 h-10 rounded-xl object-cover shadow-inner"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className={`w-10 h-10 bg-blue-600 rounded-xl items-center justify-center text-white font-bold text-lg shadow-inner ${
                  booking.vendor_info?.logo ? "hidden" : "flex"
                }`}
              >
                {booking.items[0].vendor_brand_name.charAt(0).toUpperCase()}
              </div>
              <div className="min-w-0">
                <h3 className="font-bold text-gray-900 truncate flex items-center gap-2">
                  {booking.items[0].vendor_brand_name}
                  <span className="text-[10px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-md">
                    {booking.items[0]?.vendor_type || "Service"}
                  </span>
                </h3>
                <p className="text-xs text-gray-500 truncate mt-0.5 flex items-center gap-1">
                  <FaMapMarkerAlt className="shrink-0" />
                  {booking.items[0]?.vendor_address?.officeAddress?.city ||
                    "Location"}
                </p>
              </div>
            </div>
            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-blue-200 text-blue-600 rounded-lg hover:bg-blue-50 transition font-bold text-xs"
            >
              <FaDirections /> Get Directions
            </a>
          </div>
        </div>
      )}

      {/* Services List - SCROLLABLE ON MOBILE */}
      <div className="p-4 sm:p-6 overflow-x-auto scrollbar-hide">
        <div className="min-w-[600px] lg:min-w-full space-y-3">
          {booking.items.map((service, idx) => {
            const start = new Date(service.start_date);
            const end = service.end_date ? new Date(service.end_date) : null;
            const dateDisplay =
              service.type === "boarding" && end
                ? `${start.toLocaleDateString(
                    "en-GB",
                  )} – ${end.toLocaleDateString("en-GB")}`
                : start.toLocaleDateString("en-GB");

            const duration = (() => {
              // Boarding → days
              if (service.type?.toLowerCase() === "boarding" && end) {
                const days = Math.ceil((end - start) / 86400000);
                return `${days} Day${days > 1 ? "s" : ""}`;
              }

              // Get number safely
              let val = service.duration ?? 0;
              val = Number(String(val).replace(/[^0-9.]/g, "")) || 0;

              if (val <= 0) return "N/A";

              // Category/type hints
              const isWalkingDaycare = /walking|daycare|day care/i.test(
                service.type +
                  service.service_category_name +
                  service.service_name,
              );

              const isGroomingVet = /grooming|vet/i.test(
                service.service_category_name + service.service_type_name,
              );

              // Decide unit
              let num = val;
              let unit = "min";

              if (isWalkingDaycare) {
                // Prefer hours
                num = Math.round(val <= 24 ? val : val / 60);
                unit = num === 1 ? "hr" : "hrs";
              } else if (isGroomingVet) {
                unit = "min";
              } else {
                unit = "min";
              }

              // Safety: no tiny values in minutes
              if (unit === "min" && num > 0 && num <= 15) num = 60;

              return `${num} ${unit}`;
            })();

            // Calculate item total (for display in each row)
            const itemTotal =
              //service.grand_total ||
              (service.total_price || 0) + (service.additional_amount || 0);

            return (
              <div
                key={idx}
                className="bg-gray-50 rounded-xl p-4 border border-gray-100 hover:border-orange-200 transition"
              >
                <div className="grid grid-cols-5 gap-4 items-center">
                  <div className="col-span-2">
                    <h4 className="font-bold text-sm text-gray-900 truncate flex items-center gap-2">
                      <FaTag className="text-orange-500 text-xs" />
                      {truncateString(service.service_name)}
                     
                    </h4>
                    <p className="text-[10px] text-gray-500 mt-1 flex items-center gap-1 uppercase font-bold tracking-tighter">
                      <FaPaw className="text-orange-300" /> {service.pet_name}
                    </p>
                    {/* Show extra charges if any */}
                   {/* {service.additional_amount > 0 && (
                      <p className="text-[8px] text-orange-600 font-medium mt-0.5">
                        + ₹{service.additional_amount} extra charges
                      </p>
                   )}*/}
                  </div>

                  <div className="flex items-center gap-2 text-gray-700">
                    <FaCalendarDay className="text-orange-500 text-xs shrink-0" />
                    <div className="min-w-0">
                      <p className="font-bold text-xs truncate">
                        {dateDisplay}
                      </p>
                      <p className="text-[10px] text-gray-400 font-medium">
                        {service.start_time || "Anytime"}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 text-gray-700 text-xs font-bold">
                    <FaClock className="text-orange-500 shrink-0" />
                    <span>{duration}</span>
                  </div>

                  <div className="text-right">
                    <p className="text-sm font-black text-gray-900">
                      ₹{itemTotal.toFixed(0)}
                    </p> 
                    <span
                      className={`inline-block mt-1 px-2 py-0.5 rounded-md text-[9px] font-black uppercase border ${getStatusColor(
                        service.status,
                      )}`}
                    >
                      {formatStatus(service.status)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-wrap gap-2 px-4 sm:px-6 py-4 bg-gray-50/50 border-t border-gray-100 justify-end">
        <button
          onClick={async () => {
            const invoice = await fetchInvoice(booking);
            if (invoice?.invoice_url) {
              setSelectedInvoice(invoice);
              setShowInvoice(true);
            } else {
              console.warn("No invoice_url found");
            }
          }}
          className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-200 bg-white text-gray-600 rounded-xl hover:bg-gray-50 font-bold text-xs transition"
        >
          View Invoice
        </button>
        <button
          onClick={async () => {
            const invoiceData = await fetchInvoice(booking);
            if (invoiceData?.invoice_url) {
              downloadInvoicePDF(invoiceData);
            } else {
              toast.error("Invoice URL not found on server");
            }
          }}
          className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-900 text-white rounded-xl font-bold text-xs transition shadow-lg hover:bg-black"
        >
          <FaDownload /> Download Invoice
        </button>
      </div>
    </div>
  );
};

  return (
    <div className="min-h-screen bg-[#F8FAFC] sm:py-10 px-0 sm:px-6 lg:px-8 overflow-x-hidden">
      <div className="w-full max-w-none mx-auto ">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-4 gap-4 px-4 sm:px-0">
          <div>
            <h1 className="text-xl sm:text-3xl font-black text-orange-500 tracking-tight leading-none">
              My Bookings
            </h1>
          </div>

          <div className="hidden md:flex bg-white p-1 rounded-2xl shadow-sm border border-gray-200 self-start md:self-auto">
            <button
              onClick={() => setViewMode("card")}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all ${
                viewMode === "card"
                  ? "bg-orange-500 text-white shadow-lg shadow-orange-100"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <FaThLarge /> Cards
            </button>
            <button
              onClick={() => setViewMode("list")}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all ${
                viewMode === "list"
                  ? "bg-orange-500 text-white shadow-lg shadow-orange-100"
                  : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <FaList /> List View
            </button>
          </div>
        </div>

        {/* Status Tabs */}
          <div className="px-4 sm:px-0 mb-4 flex items-center justify-between gap-4 flex-nowrap">

            <div className="flex gap-2 bg-white p-1.5 rounded-2xl w-fit whitespace-nowrap border border-gray-100 shadow-sm">
              {["Upcoming", "Past"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveStatusTab(tab)}
                  className={`px-6 py-2.5 rounded-xl font-black text-xs uppercase tracking-widest transition-all ${
                    activeStatusTab === tab
                      ? "bg-orange-500 text-white shadow-lg shadow-range-600 "
                      : "text-gray-400 hover:text-gray-600"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          {/* Mobile Filter Button */}
            <div className="sm:hidden flex items-center gap-2">
              <button
                onClick={() => setShowFilterDrawer(true)}
                className="px-3 py-2 bg-white border border-gray-200 rounded-xl shadow-sm text-xs font-semibold flex items-center gap-1.5"
              >
                <FaFilter size={12} />
                Filters
              </button>

              {selectedStatus && (
                <span className="text-[10px] text-gray-500 capitalize">
                  {selectedStatus.replace("_", " ")}
                </span>
              )}
            </div>
             {/* RIGHT → Status Filter (Single Select) */}
            <div className="hidden sm:flex flex-wrap gap-2">
              <button
                onClick={() => setSelectedStatus(null)}
                className={`px-4 py-1.5 rounded-full text-[11px] font-bold border transition-all
                  ${
                    !selectedStatus
                      ? "bg-orange-500 text-white border-orange-500 shadow-md"
                      : "bg-white text-gray-500 border-gray-200 hover:border-orange-300"
                  }`}
              >
                All
              </button>
              {STATUS_OPTIONS[activeStatusTab].map((status) => (
                <button
                  key={status}
                  onClick={() => setSelectedStatus(status)}
                  className={`px-4 py-1.5 rounded-full text-[11px] font-bold border capitalize transition-all
                    ${
                      selectedStatus === status
                        ? "bg-orange-100 text-orange-700 border-orange-300"
                        : "bg-white text-gray-500 border-gray-200 hover:border-orange-300"
                    }`}
                >
                  {status.replace("_", " ")}
                </button>
              ))}
            </div>
        </div>   
        {/* Mobile view filter drawer - bottom sheet*/}   
        {showFilterDrawer && (
          <div className="fixed inset-0 z-50 flex items-end sm:hidden">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setShowFilterDrawer(false)}
            />

            {/* Drawer */}
            <div className="relative w-full bg-white rounded-t-3xl p-5 max-h-[70vh] overflow-y-auto animate-slideUp">
              
              {/* Header */}
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">Filter by Status</h3>
                <button onClick={() => setShowFilterDrawer(false)}>
                  <FaTimes className="text-gray-500" />
                </button>
              </div>

              {/* All Button */}
              <button
                onClick={() => {
                  setSelectedStatus(null);
                  setShowFilterDrawer(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-xl mb-2 border ${
                  !selectedStatus
                    ? "bg-orange-500 text-white border-orange-500"
                    : "bg-white border-gray-200"
                }`}
              >
                All
              </button>

              {/* Status Options */}
              {STATUS_OPTIONS[activeStatusTab].map((status) => (
                <button
                  key={status}
                  onClick={() => {
                    setSelectedStatus(status);
                    setShowFilterDrawer(false);
                  }}
                  className={`w-full text-left px-4 py-3 rounded-xl mb-2 border capitalize ${
                    selectedStatus === status
                      ? "bg-orange-100 text-orange-700 border-orange-300"
                      : "bg-white border-gray-200"
                  }`}
                >
                  {status.replace("_", " ")}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Content Area */}
        {!ordersLoaded || !bookingsLoaded ? (
          <div className="min-h-[60vh] flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin w-14 h-14 border-4 border-orange-500 border-t-transparent rounded-full mx-auto mb-5"></div>
              <p className="text-lg font-medium text-gray-700">
                Loading your bookings...
              </p>
              <p className="text-sm text-gray-500 mt-2">Please wait a moment</p>
            </div>
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-24 bg-white rounded-3xl shadow-sm border border-gray-100">
            <div className="w-20 h-20 mx-auto bg-gray-50 rounded-full flex items-center justify-center text-3xl text-gray-300 mb-6">
              <FaList />
            </div>
            <h3 className="text-xl font-black text-gray-800 mb-2 uppercase tracking-tight">
              Empty Inbox
            </h3>
            <p className="text-gray-400 text-sm max-w-xs mx-auto">
              We couldn't find any bookings matching your current filters.
            </p>
          </div>
        ) : effectiveViewMode === "card" ? (
          <Listview
            bookings={filteredData}
            onViewInvoice={async (booking) => {
              const invoice = await fetchInvoice(booking);
              if (invoice?.invoice_url) {
                setSelectedInvoice(invoice);
                setShowInvoice(true);
              } else {
                toast.error("Invoice not found");
              }
            }}
            onDownloadInvoice={async (booking) => {
              const invoice = await fetchInvoice(booking);
              if (invoice?.invoice_url) {
                try {
                  await downloadInvoicePDF(invoice);
                } catch (error) {
                  console.error("Download failed:", error);
                  toast.error("Failed to download invoice. Please try again.");
                }
              } else {
                toast.error("Invoice URL not found on server");
              }
            }}
          />
        ) : (
          <div className="space-y-6">
            {filteredData.map((booking) => (
              <BookingCard key={booking.order_number} booking={booking} />
            ))}
          </div>
        )}

        {/* Modal Overlay */}
        {showInvoice && selectedInvoice && (
          <Viewinvoice
            invoiceData={selectedInvoice}
            createdAt={selectedInvoice.createdAt}
            onClose={() => setShowInvoice(false)}
            onDownload={async () => {
              if (selectedInvoice?.invoice_url) {
                try {
                  await downloadInvoicePDF(selectedInvoice);
                } catch (error) {
                  console.error("Download failed:", error);
                  toast.error("Failed to download invoice. Please try again.");
                }
              } else {
                toast.error("Invoice URL not found");
              }
            }}
          />
        )}
      </div>
    </div>
       
  );
};

